
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUnderwaysailing as ObiUnderwaysailingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-underwaysailing.js';
 
 
 

 
 export const ObiUnderwaysailing = createComponent({
   react: React,
   tagName: 'obi-underwaysailing',
   elementClass: ObiUnderwaysailingElement,
   events: {
     
   }
  });
 
 